/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { SOCIAL_PLATFORMS } from '@repo/config/social';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const socialChallengeItemSchema = z.object({
  challengeId: z.number(),
  slug: z.string(),
  phrase: z.string(),
  imageUrl: z.string().nullable(),
  clipCount: z.number(),
  versionCount: z.number(),
  latestStatus: z.enum(['generating', 'ready', 'failed']).nullable(),
  posterUrl: z.string().nullable(),
  readyVideoId: z.number().nullable(),
  readyVideoUrl: z.string().nullable(),
  postedPlatforms: z.array(z.enum(SOCIAL_PLATFORMS)).default([]),
});

export type ISocialChallengeItem = z.infer<typeof socialChallengeItemSchema>;

const listDataSchema = z.object({
  items: z.array(socialChallengeItemSchema),
  total: z.number(),
});

export interface IListSocialChallengesV1Data {
  items: ISocialChallengeItem[];
  total: number;
}

export const listSocialChallengesV1ResponseSchema = createApiResponseSchema(
  listDataSchema,
) as z.ZodSchema<IAPI<IListSocialChallengesV1Data>>;

export type IListSocialChallengesV1Response = IAPI<IListSocialChallengesV1Data>;
